<template>
  <select-field
    v-bind="$attrs"
    :value="value"
    :all-selected.sync="allSelectedValue"
    item-title="name"
    item-value="value"
    :items.sync="allVariants"
    @input="emitInput"
    @change="$emit('change', $event)"
  />
</template>
<script>
  import SelectField from './SelectField.vue'
  import { isUndefined } from 'lodash'

  export default {
    name: 'EnumSelectField',
    components: { SelectField },
    emits: ['input', 'change'],
    props: {
      value: [String, Number, Array],
      allSelected: {
        type: Boolean,
        default: false,
      },
      enumClass: null,
    },
    computed: {
      allVariants () {
        return this.enumClass ? this.enumClass.getAllVariants() : []
      },
      allSelectedValue: {
        get () {
          return this.allSelected
        },
        set (value) {
          this.$emit('update:allSelected', value)
        },
      },
    },
    methods: {
      emitInput (value) {
        if (isUndefined(value)) {
          value = null
        }
        this.$emit('input', value)
      },
    },
  }
</script>
